import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  save(event) {
    event.preventDefault();

    const multiSelectController = this.element.querySelector('[data-controller="multi-select-chips-with-search"]');
    if (!multiSelectController) return;

    const stimulus = this.application.getControllerForElementAndIdentifier(
      multiSelectController,
      'multi-select-chips-with-search'
    );

    if (!stimulus) return;

    const selectedContacts = stimulus.selectedOptions.map(opt => ({
      id: opt.value,
      name: opt.name || opt.label,
      firm_id: opt.firm_id || '',
      firm_name: opt.firm_name || ''
    }));

    window.dispatchEvent(new CustomEvent('quoteContacts:selected', {
      detail: { contacts: selectedContacts }
    }));

    const modalElement = document.getElementById('add-quote-contacts-modal');
    if (modalElement) {
      // Find the modal-manager controller (could be on the modal or a parent element)
      let element = modalElement;
      let modalManagerController = null;

      while (element && !modalManagerController) {
        modalManagerController = this.application.getControllerForElementAndIdentifier(
          element,
          'modal-manager'
        );
        element = element.parentElement;
      }

      if (modalManagerController && typeof modalManagerController.close === 'function') {
        modalManagerController.close();
      }
    }
  }
}
